









import { Component, Inject, Vue } from "vue-property-decorator";
@Component
export default class Fail extends Vue {
  @Inject()
  someValue!: { text: string };

  close(call: boolean) {
    this.$emit("close", call);
  }
}
